import { render, staticRenderFns } from "./MyKPI.vue?vue&type=template&id=815d1dfe"
import script from "./MyKPI.js?vue&type=script&lang=js&external"
export * from "./MyKPI.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports